import { createStore, Store, useStore as baseUseStore } from 'vuex'
import { State, state as storeState } from './state'
import { mutations as storeMutation } from './mutations'
import { getters as storeGetters } from './getters'
import { actions as storeActions } from './actions'

// store定義
const store = createStore<State>({
  state: storeState,
  mutations: storeMutation,
  getters: storeGetters,
  actions: storeActions,
  modules: {},
})

// storeをprovide/injectするためのキー
const key = Symbol('vuex InjectionKey')
// useStoreを使う時にキーの指定を省力するためのラッパー関数
const useStore = (): Store<State> => baseUseStore(key)

export { store, key, useStore, State }
